import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class ScoreRegistrationService {
token="eyJhbGciOiJIUzI1NiJ9.eyJ0b2tlblJlZnJlc2hLZXkiOiJmZSUyQjMwd1UlMkJNWWFIaGhCcmQlMkJ1JTJCSkJQMGJFQmo3bVRPQ2pTN3RpWmV2aWMlM0QiLCJjYW1wdXNJZCI6NTc4LCJwYXlyb2xsSWQiOiJIWUQxMDMxMzUiLCJ1c2VyTmFtZSI6IkNIIFNBVFlBTkFSQVlBTkEiLCJleHAiOjE3NDk4MDgyMDcsInVzZXJJZCI6IkhZRDEwMzEzNSIsImlhdCI6MTc0OTcyMTgwNywidW5pcXVlSWQiOjI4NDg2LCJqdGkiOiIzNzQ2OWE5NC00MDBjLTQyNmEtYWM0Zi1lYWFkMmM0NzU0MzIifQ.YoXCsVQ-9Z6g3RxqANp3d9rFD4n_XnUQxUDx_Yrh848";
  constructor(private http:HttpClient,public baseURL :BasemodelService) { }

  EntityDetails(){
     const headers = new HttpHeaders({
          'Authorization': this.token,
        });
   return  this.http.get("https://testmasters.scaits.net/employee/api/jwtV2/score/entityDetails",{headers})
  }
  getgrade(){
    const headers = new HttpHeaders({
      'Authorization': this.token,
    });
    return this.http.get("https://testmasters.scaits.net/employee/api/jwtV2/score/gradeDetails?entityName=SCAT24")
  }

}
